import { Component, input, InputSignal, inject } from '@angular/core';

import { LocaleService } from '@next/core-lib/i18n';

import { DateService } from '../../../services/date.service';

@Component({
  template: '',
  standalone: true,
})
export class TableHeaderComponent {
  private readonly dateService = inject(DateService);
  protected readonly localeService = inject(LocaleService);

  readonly selectedDates: InputSignal<Date[]> = input.required<Date[]>();

  protected isToday(date: Date): boolean {
    return this.dateService.isDateToday(date);
  }
}
